import checkPermission from '@/utils/permission'
import store from '@/store'

function applyPermission(el, binding) {
  const { value } = binding
  const permissionList = store.getters.permissionList
  const username = store.getters.name
  const roles = store.getters.roles
  const allowed = checkPermission(value, permissionList, username, roles)
  if (!allowed) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}

export default {
  inserted(el, binding) {
    applyPermission(el, binding)
  },
  update(el, binding) {
    applyPermission(el, binding)
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission.js